type CheckboxEngagementPayload = {
  eventName?: string;
  navigationGroup: string;
  checkboxValue: string;
  checkboxAction: "checked" | "unchecked";
};

const pushDataLayerEvent = (payload: Record<string, unknown>) => {
  if (typeof window === "undefined") {
    return;
  }

  const analyticsWindow = window as Window & {
    dataLayer?: Record<string, unknown>[];
  };

  analyticsWindow.dataLayer = analyticsWindow.dataLayer || [];
  analyticsWindow.dataLayer.push(payload);
};

export const trackCheckboxEngagement = ({
  eventName = "checkbox_engagement",
  navigationGroup,
  checkboxValue,
  checkboxAction,
}: CheckboxEngagementPayload) => {
  pushDataLayerEvent({
    event: eventName,
    navigation_group: navigationGroup,
    checkbox_value: checkboxValue,
    checkbox_action: checkboxAction,
  });
};
